import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Slide,
} from '@mui/material';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Loading from '../table-elements/loading.component';
import { CONTENT_ALIAS } from '../../config/const.config';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ListSequencePodcast = ({
  handleOnDragEndPodcasts,
  handleUpdatePodcastSequence,
  action,
  selectedShow,
  showPodcastList,
  podcastOptions,
  handleCloseDialog,
}) => (
  
  <Dialog
    open={action.show}
    aria-describedby="channel-category-videos"
    aria-labelledby="channel-category-videos"
    TransitionComponent={Transition}
    fullWidth
    maxWidth="md"
  >
    <DialogTitle>{`Reorder ${CONTENT_ALIAS.PODCAST_PLURAL} Sequence - ${selectedShow.title}`}</DialogTitle>

    <DialogContent dividers>
      {podcastOptions.loading && <Loading />}

      {!podcastOptions.loading && (
        <DragDropContext onDragEnd={handleOnDragEndPodcasts}>
          <Droppable droppableId="videos">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {!podcastOptions.loading &&
                  showPodcastList.length > 0 &&
                  showPodcastList.map((video, index) => (
                    <Draggable
                      key={`video-${video.id}`}
                      draggableId={video.id.toString()}
                      index={index}
                    >
                      {(provide) => (
                        <Card
                          sx={{
                            marginBottom: '5px',
                          }}
                          ref={provide.innerRef}
                          {...provide.draggableProps}
                          {...provide.dragHandleProps}
                        >
                          <CardContent
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              paddingY: '12px',
                              '&:last-child': {
                                paddingBottom: '12px',
                              },
                            }}
                          >
                            <div>{video.title || video.name}</div>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            />
                          </CardContent>
                        </Card>
                      )}
                    </Draggable>
                  ))}

                {!podcastOptions.loading && showPodcastList.length === 0 && (
                  <Paper
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    No data available.
                  </Paper>
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </DialogContent>

    <DialogActions>
      <Button
        onClick={handleUpdatePodcastSequence}
        disabled={
          showPodcastList.length === 0 || showPodcastList.length === 1
        }
        variant="contained"
      >
        Save
      </Button>
      <Button onClick={handleCloseDialog} variant="contained">Cancel</Button>
    </DialogActions>
  </Dialog>
);

ListSequencePodcast.propTypes = {
  handleOnDragEndPodcasts: PropTypes.func.isRequired,
  handleUpdatePodcastSequence: PropTypes.func.isRequired,
  action: PropTypes.object.isRequired,
  selectedShow: PropTypes.object.isRequired,
  showPodcastList: PropTypes.array.isRequired,
  podcastOptions: PropTypes.object.isRequired,
  handleCloseDialog: PropTypes.func.isRequired,
};

export default ListSequencePodcast;
